import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { catchError, filter, map, Observable } from 'rxjs';
import { RobotPart } from '../models/robot-part';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class RobotPartService extends ApiService {
  // TODO: Add a system for direct queries to a specific part, by the open model and part number

  getRobotPart(id: number): Observable<RobotPart> {
    return this.get(RobotPart, `robot_parts/${id}`, 60);
  }

  // Most of the 'Closest' match sorting occurs server-side with psql selects.
  getClosestMatchingQuery(query: string, explorer_model_id: number): Observable<RobotPart> {
    return this.getMatchingQuery(query, explorer_model_id, true).pipe(map(value => value[0]));
  }

  getMatchingQuery(query: string, explorer_model_id: number, sort_closest: boolean = false): Observable<RobotPart[]> {
    return this.queryRobotParts(query, explorer_model_id, sort_closest);
  }

  getAutocompleteSuggestionsForModel(explorer_model_id: number) {
    return this.getAutocompleteMatches(explorer_model_id);
  }

  getByModelName(part_model_name: string, explorer_model_id: number): Observable<RobotPart[]> {
    const url = `explorer_models/${explorer_model_id}/robot_parts`;
    return this.list(RobotPart, url, { part_model_name }, 60);
  }

  getByPartNumber(part_number: string, explorer_model_id: number): Observable<RobotPart[]> {
    const url = `explorer_models/${explorer_model_id}/robot_parts`;
    return this.list(RobotPart, url, { fru: part_number }, 60);
  }

  getAllAutocompleteSuggestions() {
    return this.getAutocompleteMatches();
  }

  getSystemCheckList(explorer_model_id, query): Observable<RobotPart[]> {
    return this.queryRobotParts('!' + query, explorer_model_id);
  }

  private queryRobotParts(query: string, explorer_model_id: number, sort_closest: boolean = false): Observable<RobotPart[]> {
    const url = `explorer_models/${explorer_model_id}/robot_parts`;
    let sanitizedQuery = query.startsWith('#') ? query.substring(1) : query;
    if (sanitizedQuery.startsWith('JDHDW')) {
      sanitizedQuery = /^([A-Z]{5}[0-9]+)([-_][0-9]{0,3}|[-_]ASM)*$/.exec(sanitizedQuery)[1];
    }

    let searchParams = query.startsWith('#') ? { fru: sanitizedQuery }
      : query.startsWith('!') ? { sysCheck: query.substring(1) }
        : { search: sanitizedQuery };
    if (query.startsWith('!')) {
      searchParams = { sysCheck: query.substring(1) };
    }
    const list = this.list(RobotPart, url, searchParams, 60);
    return !sort_closest ? list : list.pipe(map(values => values.sort((partA, partB) => partB.nameCloseness(query) - partA.nameCloseness(query))));
  }

  private getAutocompleteMatches(explorer_model_id?: number): Observable<string[]> {
    const url = (explorer_model_id ? `explorer_models/${explorer_model_id}` : ``) + `/robot_parts/autocomplete_suggestions`;
    return this.http.get<string[]>(this.url(url)).pipe(
      filter(response => !_.isNil(response)),
      catchError(e => this.handleError(e)));
  }
}
